<script setup>
import SummaryProgram from './Items/SummaryProgram.vue';
import SummaryTariff from './Items/SummaryTariff.vue';
</script>

<template>
  <SummaryProgram/>
  <SummaryTariff/>
</template>
